import React, { FC, useState } from 'react';
import { required, SaveButton, TextInput } from 'react-admin';
import { makeStyles } from '@material-ui/core';
import BlockIcon from '@material-ui/icons/Block';

import Drawer from '~/components/Drawer';
import { SimpleForm } from '~/components/ra';
import Toolbar from '~/components/ra/Toolbar';
import { revokeDevice } from '~/api/apiIdentity';
import useApiLazy from '~/hooks/useApiLazy';
import { useApiIdentityTranslate } from '..';
import DeleteButton from '~/components/DeleteButton';

interface Props {
  apiIdentityId: string;
  deviceId: string;
  refetch: () => void;
}

const RevokeDeviceAction: FC<Props> = (props) => {
  const { apiIdentityId, deviceId, refetch } = props;
  const [open, setOpen] = useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const t = useApiIdentityTranslate();
  const classes = useStyles();

  const [request, { loading }] = useApiLazy(revokeDevice, [], {
    onSuccess: () => {
      refetch();
      handleClose();
    },
  });

  const handleSave = (formData: any) => {
    request({ apiIdentityId, deviceId, reason: formData.reason });
  };

  return (
    <>
      <DeleteButton label={t('revoke')} onClick={handleOpen} />
      <Drawer heading={t('revoke')} open={open} onClose={handleClose}>
        <SimpleForm
          toolbar={
            <Toolbar>
              <SaveButton
                label={t('revoke')}
                className={classes.revokeButton}
                onSave={handleSave}
                icon={<BlockIcon />}
              />
            </Toolbar>
          }
          saving={loading}
        >
          <TextInput
            source='reason'
            label={t('reason')}
            multiline
            rows={5}
            rowsMax={20}
            validate={required()}
            fullWidth
          />
        </SimpleForm>
      </Drawer>
    </>
  );
};

const useStyles = makeStyles((theme) => ({
  revokeButton: {
    backgroundColor: theme.palette.error.main,
    '&:hover': {
      background: theme.palette.error.dark,
    },
  },
}));

export default RevokeDeviceAction;
